import React, { useState } from "react";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import { TabPanel, useTabStyle } from "App/Component/ui";
import TabItem from "./TabItem";
import TabJasa from "./TabJasa";
import TabFasilitas from "./TabFasilitas";
import TabPaket from "./TabPaket";
import TabRikjang from "./TabRikjang";

function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

function TabSummary() {
  const classes = useTabStyle();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.rootTab}>
        <AppBar
          position='static'
          classes={{
            root: classes.appbar,
          }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant='fullWidth'
            aria-label='Tabs Input Penjualan'
            classes={{
              root: classes.tabs,
              flexContainer: classes.fixedTab,
            }}>
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='ITEM'
              {...a11yProps(0)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='JASA'
              {...a11yProps(1)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='FASILITAS'
              {...a11yProps(2)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='RIKJANG'
              {...a11yProps(3)}
            />

            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='PAKET'
              {...a11yProps(4)}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <TabItem />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TabJasa />
        </TabPanel>{" "}
        <TabPanel value={value} index={2}>
          <TabFasilitas />
        </TabPanel>{" "}
        <TabPanel value={value} index={3}>
          <TabRikjang />
        </TabPanel>{" "}
        <TabPanel value={value} index={4}>
          <TabPaket />
        </TabPanel>
      </div>
    </div>
  );
}

export default TabSummary;
